import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { api, fmtDate } from "@/lib/api";
import { Plus, CalendarDays, Users, Eye } from "lucide-react";

const statusColor = {
    pending_review: "bg-amber-100 text-amber-800",
    published: "bg-emerald-100 text-emerald-800",
    registration_open: "bg-emerald-100 text-emerald-800",
    registration_closed: "bg-slate-100 text-slate-700",
    completed: "bg-slate-100 text-slate-700",
    archived: "bg-slate-100 text-slate-500",
    draft: "bg-slate-100 text-slate-600",
};

export default function HostDashboard() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => { (async () => {
        const res = await api.get("/host/events"); setEvents(res.data); setLoading(false);
    })(); }, []);

    return (
        <Shell>
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
                <div className="flex items-end justify-between flex-wrap gap-4">
                    <div>
                        <div className="label-base">Host</div>
                        <h1 className="font-heading text-3xl md:text-4xl font-extrabold">Your events</h1>
                    </div>
                    <Link to="/host/events/new" data-testid="host-new-event" className="pill btn-coral inline-flex items-center gap-2 px-5 py-3 font-semibold">
                        <Plus size={16} /> New event
                    </Link>
                </div>

                <div className="mt-8 grid lg:grid-cols-2 gap-5">
                    {loading ? <div className="text-brand-mute">Loading…</div> :
                     events.length === 0 ? (
                        <div className="rounded-xl border border-dashed border-brand-line p-12 text-center bg-white lg:col-span-2">
                            <h3 className="font-heading text-xl font-bold">No events yet</h3>
                            <p className="text-brand-mute mt-2">Spin up your first health fair in under ten minutes.</p>
                            <Link to="/host/events/new" className="pill btn-coral inline-flex items-center gap-2 mt-5 px-5 py-3 font-semibold"><Plus size={16} /> Create event</Link>
                        </div>
                     ) : events.map((ev) => (
                        <div key={ev.id} className="rounded-xl border border-brand-line bg-white p-6 card-hover" data-testid={`host-event-${ev.id}`}>
                            <div className="flex items-start justify-between gap-3">
                                <div>
                                    <span className={`px-2.5 py-0.5 rounded-md text-xs font-semibold ${statusColor[ev.status] || "bg-slate-100 text-slate-600"}`}>{ev.status.replace("_", " ")}</span>
                                    <h3 className="font-heading text-xl font-bold mt-3">{ev.name}</h3>
                                </div>
                                <Link to={`/host/events/${ev.id}`} className="text-sm font-semibold text-brand-forest inline-flex items-center gap-1 hover:underline">Manage <Eye size={14} /></Link>
                            </div>
                            <div className="mt-3 flex flex-col gap-1.5 text-sm text-brand-mute">
                                <span className="inline-flex items-center gap-2"><CalendarDays size={14} /> {fmtDate(ev.event_date)}</span>
                                <span className="inline-flex items-center gap-2"><Users size={14} /> {ev.application_count} applications · {ev.confirmed_count} confirmed</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Shell>
    );
}
